import { Injectable } from '@angular/core';
import {  HttpGeneralService} from '../../shared';
import {PatientVisit} from './patient-visit';
import { CONFIG } from '../../shared/config';
let regPatVisitUrl = CONFIG.baseUrls.regPatVisit;


@Injectable()
export class PatientVisitsService {
    constructor(
        private _httpGeneralService: HttpGeneralService) {

    }
    // update visit to cancelled or to closed
    updateSpecificVisit(patientVisit: PatientVisit) {
        return this._httpGeneralService.update<PatientVisit>(patientVisit.serial, patientVisit, `${regPatVisitUrl}`);

    }
    // get visit to cancel or to close
    getSpecificVisit(id: number, nextVisitStatus: number) {
        return this._httpGeneralService.getWith(`${regPatVisitUrl}/${id}/${nextVisitStatus}`);

    }
    CancelSpecificVisit(id: number, nextVisitStatus: number) {
        return this._httpGeneralService.getWith(`${regPatVisitUrl}/CancelSpecificVisit/${id}/${nextVisitStatus}`);

    }



    updateCloseSpecificVisit(patientVisit: PatientVisit) {
        return this._httpGeneralService.update<PatientVisit>(patientVisit.serial, patientVisit, `${regPatVisitUrl}/putClosePatVisit`);

    }


}
